const formSections = {
  PATIENT_SECTION: "patient",
  CONDITION_SECTION: "condition",
  ELIGIBILITYANDATTESTATION_SECTION: "eligibilityAndAttestation",
  SUPPORTOPTIONS_SECTION: "supportOptions"
};

export { formSections };
